import React from 'react';
import { appConfig } from '../../utils/appConfig';
import { classNames } from '../../utils/classNames';

export interface ProductCollectionListProps<T extends { id: string; title: string }> {
  items: Array<T>;
  activeId?: string;
  renderItem: (item: T, selected: boolean) => React.ReactNode;
  dark?: boolean;
  step?: number | `${number}`;
  itemsLabel?: string;
}

function ProductCollectionList<T extends { id: string; title: string }>({
  items,
  activeId,
  renderItem,
  itemsLabel = 'items available',
}: ProductCollectionListProps<T>) {
  const activeItem = items.find((i) => i.id === activeId);

  return (
    <div className="grid gap-4">
      <p className="sr-only">
        {items.length} {itemsLabel}
        {activeItem && `, selected option is ${activeItem.title}`}
      </p>
      <ul role="list" className={classNames('p-0 grid list-none', appConfig.isTraeger && 'gap-4')}>
        {items.map((item) => (
          <React.Fragment key={item.id}>{renderItem(item, item.id === activeId)}</React.Fragment>
        ))}
      </ul>
    </div>
  );
}

export default ProductCollectionList;
